import wpdmIcons from "../../libs/icons";
import Select from 'react-select'
import makeAnimated from 'react-select/animated';

const {registerBlockType} = wp.blocks;
const {InspectorControls, MediaUpload} = wp.editor;
const {TextControl, SelectControl, FormToggle, ServerSideRender, Modal, Button, PanelBody, IconButton} = wp.components;

const { __ } = wp.i18n;

const animatedComponents = makeAnimated();

registerBlockType('download-manager/dashboard', {
    title: 'Dashboard',

    description: 'Download Manager User Dashboard',

    keywords: [
        __( 'download manager signup form digital ecommerce store product sell' ),
        __( 'file manager' ),
        __( 'login signin form' ),
    ],

    icon: wpdmIcons.dashboard(),

    category: 'wpdm-blocks',

    attributes: {
        logo: {
            type: 'string',
            default: ''
        },
        recommended: {
            type: 'string',
            default: 'recent'
        },
        fav: {
            type: 'integer',
            default: 1
        },
        note_before: {
            type: 'string',
            default: ''
        },
        note_after: {
            type: 'string',
            default: ''
        },
        regurl: {
            type: 'string',
            default: ''
        },
        redirect: {
            type: 'string',
            default: ''
        },
        className: {
            type: 'string',
            default: ''
        }
    },

    edit({attributes, className, setAttributes}) {

        const _recommend = wpdm_categories;
        if(_recommend[1].value !== 'recent') {
            _recommend.unshift({label: 'Recent Item', value: 'recent'});
            _recommend.unshift({label: 'Hide', value: ''});
        }

        function onSelectCategory(category) {
            setAttributes({ recommended: category.value });
        }

        function selectedCategory(category) {

            jQuery.each(_recommend, function (index, _category) {
                if(_category.value === category){
                    return _category;
                }
            });
            return null;
        }

        return [

            <InspectorControls>
                <div className="w3eden">
                    <PanelBody>
                        <div className="form-group">
                            <label>Recommend:</label>
                            <Select
                                id = {"recommended"}
                                name = {"recommended"}dashboard
                                components={animatedComponents}
                                defaultValue={selectedCategory(attributes.recommend)}
                                options={_recommend}
                                onChange={ ( recommend ) => onSelectCategory(recommend) }
                            />
                        </div>
                        <div className={"form-group"}>
                            <FormToggle
                                id={"fav"}
                                checked={attributes.fav}
                                onChange={fav => {
                                    setAttributes({fav: fav.target.checked});
                                }}
                            />
                            <label htmlFor={"fav"} style={{paddingLeft: "5px"}}> Show Favourites</label>
                        </div>
                    </PanelBody>
                    <PanelBody title={__('Login Form Options')}>
                    <TextControl
                        label="Redirect URL ( Optional )"
                        help={ 'Where you want to redirect user after login' }
                        value={ attributes.redirect }
                        onChange={ ( url ) => setAttributes( { redirect: url } ) }
                    />
                    <TextControl
                        label="Signup Page URL ( Optional )"
                        help={ 'If you have multiple signup page, you can specify one here' }
                        value={ attributes.redirect }
                        onChange={ ( url ) => setAttributes( { redirect: url } ) }
                    />
                    </PanelBody>
                    <PanelBody title={__('Login Form Notes')}>
                        <TextControl
                            label="Before Form:"
                            help={ 'Write if you have any special instructions' }
                            value={ attributes.note_before }
                            onChange={ ( note_before ) => setAttributes( { note_before: note_before } ) }
                        />
                        <TextControl
                            label="After Form:"
                            help={ 'Write if you have any special instructions' }
                            value={ attributes.note_after }
                            onChange={ ( note_after ) => setAttributes( { note_after: note_after } ) }
                        />
                    </PanelBody>
                    <PanelBody title={__('Login Form Logo:')}>
                        <MediaUpload
                            onSelect={  img => {
                                setAttributes( {
                                    logo: img.url
                                } )} }
                            type="image"
                            value={ attributes.logo }
                            render={ ( { open } ) => (
                                <div>
                                    <IconButton
                                        className="ab-cta-inspector-media"
                                        label={ __( 'Edit image' ) }
                                        icon="format-image"
                                        onClick={ open }
                                    >
                                        { __( 'Select Image' ) }
                                    </IconButton>

                                    { attributes.logo && !! attributes.logo.length && (
                                        <div>
                                            <img style={{margin: "10px 0", height: "128px", width: 'auto'}} src={attributes.logo} />
                                        <IconButton
                                            className="ab-cta-inspector-media"
                                            label={ __( 'Remove Image' ) }
                                            icon="dismiss"
                                            onClick={ () => {
                                                setAttributes({
                                                    logo: ''
                                                })
                                            } }
                                        >
                                            { __( 'Remove' ) }
                                        </IconButton>
                                        </div>
                                    ) }
                                </div>
                            ) }
                        >
                        </MediaUpload>
                    </PanelBody>
                </div>
            </InspectorControls>
            ,
            <ServerSideRender
                block={"download-manager/dashboard"}
                attributes = {attributes}
                />
            ];
    },
    save() {
        return null;
    }
});
